import React from 'react';

/**
 * @param {string} className - Mandatory to add the height & width. Use tailwind's h-[x] and w-[x] classes.
 * @param {boolean} rounded - Whether to apply rounded corners to the skeleton.
 */

type SkeletonProps = {
  className: string;
  rounded?: boolean;
};
const Skeleton = ({ className, rounded }: SkeletonProps) => (
  <div
    className={`${className ?? 'w-4 h-4'} bg-gray-100 ${
      rounded ? 'rounded-full' : ''
    } animate-pulse`}
  />
);

export default Skeleton;
